import { useState } from 'react';
import ModalButton from 'components/CustomButtons/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button/Button';
import VerticalAlignBottom from '@material-ui/icons/VerticalAlignBottom';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';
import { Tooltip } from '@material-ui/core';
import IconReceiptLong from 'assets/Icons/IconReceiptLong';

import OrdersContainer from '../../Orders/Orders.container';

const useStyles = makeStyles({
  modalButton: {
    position: 'absolute',
    top: '0',
    right: '0',
    cursor: 'pointer',
  },
  button: {
    fontSize: '14px',
    fontWeight: '500',
    padding: '2px 6px',
    margin: '-2px -6px',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
});

const SubscriptionOrders = ({ subscription, isIcon }) => {
  const { t } = useTranslation();

  const classes = useStyles();

  const [subscriptionOrdersModal, setSubscriptionOrdersModal] = useState(false);

  const closeModal = () => setSubscriptionOrdersModal(false);
  const openModal = () => setSubscriptionOrdersModal(true);

  const customActions = row => {
    const actions = [];

    if (row.invoicePDF !== null) {
      actions.push({
        action: props => window.open(props.row.invoicePDF, '_blank'),
        icon: <VerticalAlignBottom />,
        disabled: row.invoicePDF === null,
        color: row.invoicePDF ? 'primary' : 'tumblr',
        simple: true,
        round: false,
      });
    }

    return actions;
  };

  return (
    <>
      <Dialog
        fullScreen={true}
        open={subscriptionOrdersModal}
        onClose={closeModal}
      >
        <DialogContent>
          <ModalButton
            className={classes.modalButton}
            color="transparent"
            justIcon={true}
            round={true}
            onClick={closeModal}
          >
            &times;
          </ModalButton>
        </DialogContent>
        <DialogContent>
          <OrdersContainer
            defaultQuery={{ subscription: subscription.id }}
            showAddButton={false}
            customActions={customActions}
            customActionsWidth={50}
          />
        </DialogContent>
      </Dialog>
      {isIcon ? (
        <Tooltip
          onClick={openModal}
          title={t('subscription.dialog.orders.tooltip')}
          placement="top"
        >
          <IconReceiptLong />
        </Tooltip>
      ) : (
        <Button className={classes.button} onClick={openModal}>
          {t('subscription.orders.showButton')}
        </Button>
      )}
    </>
  );
};

export default SubscriptionOrders;
